import Vue from 'vue';

import { validateHasPermissions } from '~/helpers/_core/safea-permissions';


const _checkStringValue = (valueReceived, features, vnode) => {
  const hasPermission = features.find(item => {
    return item.alias === valueReceived;
  });

  if (!hasPermission) {
    vnode.elm.parentElement.removeChild(vnode.elm);
  }
};

const _checkArrayValue = (arrayReceived, features, vnode) => {
  let removeEl = true;

  arrayReceived.forEach(valueReceived => {
    const hasPermission = features.find(item => {
      return item.alias === valueReceived;
    });

    if (hasPermission) {
      removeEl = false;
    }
  });

  if (removeEl) {
    vnode.elm.parentElement.removeChild(vnode.elm);
  }
};

const _inserted = (features, value, vnode) => {
  if (typeof value === 'string' || value instanceof String) {
    _checkStringValue(value, features, vnode);
  } else if (value instanceof Array) {
    _checkArrayValue(value, features, vnode);
  }
};

const options = {
  _inserted
};

export {
  options
};

Vue.directive('safea-permission', {
  // Quando o elemento vinculado é inserido no DOM...
  inserted(el, binding, vnode, old) {
    const features = vnode.context.$store.state._core.application.feature;
    const value = binding.value || null;

    options._inserted(features, value, vnode);
  }
});

export default ({ store }, inject) => {
  inject('safea', {
    hasPermissions(...requestedPermissions) {
      return validateHasPermissions(requestedPermissions, store.state._core.user.permissions);
    }
  });
};
